module.exports = __webpack_public_path__ + "static/media/PRO_DECK SWITCH_PICTURE.92a39c43.jpg";